import React from "react";

import { Box, Button, TextField, Typography } from "@mui/material";


import * as Api from 'api/api';
// import * as UsersApi from 'api/users';
import { ApiUser } from "api/users";


import * as F from 'tsui/Form';
import PageContents from "components/PageContents";
import { ApiProducts } from "api";
import { convertProductData } from "data/ConvertProductData";




interface UserDetailsTabProps {
    onClose: () => void;

}



export default function AddProductDialog(props: UserDetailsTabProps) {

    const [data, setData] = React.useState<ApiProducts | null>(null);
    let [dataRequested, setDataRequested] = React.useState(false);

    const mounted = React.useRef(false);

    const form = F.useInputForm();



    const onSubmit = React.useCallback((evt: F.InputFormEvent) => {

        let cardType = evt.data.cardType
        let productData = convertProductData(evt)


        Api.requestSessionJson('products', 'add_product', {cardType: cardType}, productData).then(d => {

            props.onClose();
        }).catch(err => console.log(err));

    }, []);



    return <F.PageFormDialog title='User' form={form} size='md' onSubmit={onSubmit} onClose={props.onClose}>

        <F.InputText label='Card Type' id='cardType' autocomplete='given-name' value='' form={form} xs={3.5} />

        <F.InputGroup label='AMD' form={form} />
        <F.InputText label='Currency' id='currency' autocomplete='given-name' value='AMD' readonly form={form} xs={3.5} />
        <F.InputText label='Currency Code' id='currencyCode' autocomplete='given-name' readonly value='051' form={form} xs={3.5} />
        <F.InputText label='Amount' id='amount_amd' autocomplete='given-name' value='' form={form} xs={3.5} />

        <F.InputGroup label='USD' form={form} />
        <F.InputText label='Currency' id='currency' autocomplete='given-name' value='USD' readonly form={form} xs={3.5} />
        <F.InputText label='Currency Code' id='currencyCode' autocomplete='given-name' readonly value='840' form={form} xs={3.5} />
        <F.InputText label='Amount' id='amount_usd' autocomplete='given-name' value='' form={form} xs={3.5} />

        <F.InputGroup label='RUB' form={form} />
        <F.InputText label='Currency' id='currency' autocomplete='given-name' value='RUB' readonly form={form} xs={3.5} />
        <F.InputText label='Currency Code' id='currencyCode' autocomplete='given-name' value='643' readonly form={form} xs={3.5} />
        <F.InputText label='Amount' id='amount_rub' autocomplete='given-name' value='' form={form} xs={3.5} />

    </F.PageFormDialog>


}

